"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const constants_1 = require("../../constants");
const Flex_1 = require("../Flex");
const Icon_1 = require("../Icon");
const RightSlot = styled_1.default.div({
    marginLeft: 'auto',
    paddingLeft: constants_1.theme.spacing['3.5'],
    color: constants_1.Color.DARK_GREY,
    '[data-highlighted] > &': { color: constants_1.Color.CHARCOAL },
});
const ItemContent = (props) => {
    return ((0, jsx_runtime_1.jsxs)(Flex_1.Flex, { gap: 2, items: "center", children: [(0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: props.icon, color: constants_1.Color.DARK_GREY, size: "sm" }), (0, jsx_runtime_1.jsx)("p", { children: props.children }), (0, jsx_runtime_1.jsx)(RightSlot, { children: props.rightSlot })] }));
};
exports.ItemContent = ItemContent;
